import React, { FunctionComponent, MutableRefObject } from 'react';

import { useIntl } from 'react-intl';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { ContentSection } from './components/Section';
import Animations from './components/Animations';
import EmailInput from './components/EmailInput';

type SectionContact = {
  sectionRef: MutableRefObject<null>;
};

const SectionContact: FunctionComponent<SectionContact> = ({ sectionRef }) => {
  const { formatMessage } = useIntl();

  return (
    <ContentSection alignment="center" sectionRef={sectionRef}>
      <Box mb={10}>
        <Animations />
      </Box>
      <Typography variant="h3">
        {formatMessage({ id: `contact.title` })}
      </Typography>
      <Box my={2}>
        <Typography color="textPrimary">
          {formatMessage({ id: `contact.text` })}
        </Typography>
      </Box>
      <EmailInput />
    </ContentSection>
  );
};

export default SectionContact;
